import { render, staticRenderFns } from "./SeafarerDashboard.vue?vue&type=template&id=0dfc7846"
import script from "./SeafarerDashboard.vue?vue&type=script&lang=ts"
export * from "./SeafarerDashboard.vue?vue&type=script&lang=ts"
import style0 from "./SeafarerDashboard.vue?vue&type=style&index=0&id=0dfc7846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports